import { IAffairPub, IAffairUploadImageApi, IAttachmentImage } from "@api/affair.int";
import { Box } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { useVVStore } from "components/store";
import { RemoteButton } from "components/RemoteButton";
import { DeepAuthContext } from "features/auth/DeepAuth";
import { ChangeEvent, useContext, useRef, useState } from "react";
import { VizvButtonPrimary } from "components/vizvComponents";
import { MdAddAPhoto, MdVideocam } from "react-icons/md";
import { AffairContext } from "./Affair";
import { useNavigate } from "react-router";

const MAX_IMAGE_SIZE = 1000000;
const MAX_IMAGE_SIZE_PX = 1024;
export const MIME = 'image/jpeg';

/*
            console.log('length: ', e.target.result.includes('data:image/jpeg'))
            if (!e.target.result.includes('data:image/jpeg')) {
                return alert('Wrong file type - JPG only.')
            }
            if (e.target.result.length > MAX_IMAGE_SIZE) {
                return alert('Image is loo large.')
            }
            uploadImage(e.target.result);
*/

/*export interface AffairImageUploadProps {
    affair: IAffairPub;
    onImageUploaded: (affair: IAffairPub, newKey : string) => void;
}*/

export function AffairImageUpload() {
	const affairCtx = useContext(AffairContext);
    const authCtx = useContext(DeepAuthContext);
    const api = useVVApi();
    const store = useVVStore();

	const nav = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const fileRef = useRef<HTMLInputElement>(null);


    const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        let files = e.target.files || [];
        if (!files.length)
            return

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;


        const bitmap = await createImageBitmap(files[0]);
        const { width, height } = bitmap

        const ratio = Math.min(MAX_IMAGE_SIZE_PX / width, MAX_IMAGE_SIZE_PX / height)

        const resizedWidth = Math.floor(width * ratio);
        const resizedHeight = Math.floor(height * ratio);

        canvas.width = resizedWidth;
        canvas.height = resizedHeight;


        ctx.drawImage(bitmap, 0, 0, width, height, 0, 0, resizedWidth, resizedHeight)

        canvas.toBlob(blob => {
            if (blob)
                uploadImage(blob);
        }, MIME, 1)
    }

    const uploadImage = async (blobData: Blob) => {
        setIsLoading(true);
        try {
            const resp = await api.fetchToast<IAffairUploadImageApi>({
                url: "/affair/:affairKey/upload-image", method: 'POST',
                params: {
                    affairKey: affairCtx.affair.affairKey
                },
                payload: {
                    mime: MIME
                }
            });
            console.log('----->', resp);
            console.log('Uploading to: ', resp.uploadURL)
            const result = await fetch(resp.uploadURL, {
                method: 'PUT',
                body: blobData
            })
            console.log('Result: ', result)
            // Final URL for the user doesn't need the query string params
            console.log('uploadURL', resp.uploadURL.split('?')[0]);

            const newAffair: IAffairPub = {
                ...affairCtx.affair,
                attachments: {
                    ...affairCtx.affair.attachments,
                    [resp.metadata.attachmentKey]: {
                        attachKind: 'uploded_image',
                        createdAt: 'most',
                        key: resp.key,
                        user: {
                            ...authCtx.userConfirmed
                        }
                    } as IAttachmentImage
                }
            }

            // refresh in store, and refresh here...
            affairCtx.setAffair(newAffair, resp.metadata.attachmentKey);
        } catch (ex) { } finally {
            setIsLoading(false);
        }
    }


    return <>
        <VizvButtonPrimary  isLoading={isLoading} onClick={() => fileRef.current?.click()} leftIcon={<MdAddAPhoto />}   
            protLev={affairCtx.isOwnAffair ?  'anyuser' : 'confirmed'}
        >Képet töltök fel</VizvButtonPrimary>
        <Box display='none'><input type="file" onChange={onFileChange} accept="image/jpeg" ref={fileRef} /></Box>
    </>
}